import 'hammerjs';
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

// Import AWS Amplify
import { Amplify } from 'aws-amplify';

import * as moment from 'moment';
import 'hammerjs';

let serverURL = environment.awsEUServer;

// Set the production server url
if (environment.production) {
    if (moment().utcOffset() >= 0) { // EU
        serverURL = environment.awsEUServer;
    } else { // US
        serverURL = environment.awsUSServer;
        }
    }

// Log environment variables for debugging


// Define the Amplify configuration (removed Lex interactions as they're now handled by backend)
const amplifyConfig = {
    Auth: {
        region: environment.awsRegion,
        userPoolId: environment.awsUserPoolId,
        userPoolWebClientId: environment.awsUserPoolWebClientId
    },
    API: {
        endpoints: [
            {
                name: environment.awsAPIName,
                endpoint: serverURL,
                custom_header: async () => {
                    try {
                        const user = await Amplify.Auth.currentAuthenticatedUser();
                        return {Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`};
                    } catch (e) {
                        return {};
                    }
                }
            }
        ]
    }
};

// Configure Amplify with the defined configuration
Amplify.configure(amplifyConfig);


if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
